export default __webpack_public_path__ + "3df1769763f372cd158bab147e3ee85f.png";